import { type Settings } from '@/settings';

import { currentOrigin } from './currentOrigin';

/** staging settings overrides */
export const settings: Partial<Settings> = {
  BASE_API_ORIGIN: currentOrigin(),
  CSRF_COOKIE_NAME: '__Host-evolveappstorecsrfstaging',
  GOOGLEMAPS_API_KEY: '',
  MCP_SERVER_URL: 'https://mcp.studio.burnsred.ai/mcp',
};

export default settings;
